import { useCallback, useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useRouter } from '@shared/hooks/use-router'
import { apiJSON } from '@shared/utils/api/api.util'

export function useAuditMutation(
  endpoint: string,
  method: 'PUT' | 'DELETE' | 'POST',
  payload: object = {}
) {
  const { navigate } = useRouter()
  const [isConfirmAuditMutationDialogOpen, setConfirmAuditMutationDialogOpen] =
    useState(false)

  const queryClient = useQueryClient()

  const { mutateAsync: mutateAudit, isLoading: isAuditMutationInProgress } =
    useMutation(() => apiJSON(endpoint, payload, { method }), {
      onSuccess: () => {
        queryClient.invalidateQueries('CompaniesEvaluationProfiles')
      },
    })

  const onAuditActionConfirmation = useCallback(
    async (confirm: boolean) => {
      if (confirm) {
        await mutateAudit()
        navigate('/')
      }

      setConfirmAuditMutationDialogOpen(false)
    },
    [setConfirmAuditMutationDialogOpen, mutateAudit, navigate]
  )

  const onAuditMutationStart = useCallback(async () => {
    setConfirmAuditMutationDialogOpen(true)
  }, [setConfirmAuditMutationDialogOpen])

  return {
    isConfirmAuditMutationDialogOpen,
    isAuditMutationInProgress,
    onAuditMutationStart,
    onAuditActionConfirmation,
  }
}
